import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const LogOutIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fill='currentColor'
                d='M3.6 20.4C4 20.8 4.472 21 5.016 21L18.984 21C19.544 21 20.02 20.8 20.412 20.4C20.804 20 21 19.528 21 18.984V17H18.984V18.984L5.016 18.984L5.016 5.016L18.984 5.016V7H21V5.016C21 4.472 20.804 4 20.412 3.6C20.02 3.2 19.544 3 18.984 3L5.016 3C4.472 3 4 3.2 3.6 3.6C3.2 4 3 4.472 3 5.016L3 18.984C3 19.528 3.2 20 3.6 20.4Z'
            />
            <Path
                fill='currentColor'
                fillRule='evenodd'
                clipRule='evenodd'
                d='M15.08 15.616L17.648 13H8V11.032H17.648L15.08 8.416L16.496 7L21.512 12.016L16.496 17.032L15.08 15.616Z'
            />
        </>
    ),
})

LogOutIcon.displayName = 'LogOutIcon'
